import React from 'react';

import { cn } from '../cn';
import { type BadgeProps } from './Badge';

export const BadgePropsSize = ['sm', 'xs'] as const;
export const BadgePropsType = ['standard', 'success', 'warning', 'dangerous'] as const;

export type BadgeContainerProps = Pick<BadgeProps, 'type' | 'rounded' | 'className' | 'children'> & {
  ref?: React.Ref<HTMLElement>;
};

const BadgeContainer = ({ type, className, rounded, children, ref }: BadgeContainerProps) => {
  return (
    <span
      className={cn(
        'inline-flex flex-row items-center overflow-hidden rounded border text-sm no-underline',

        { 'rounded-full': rounded },
        'border-zumthor-300 bg-zumthor-50 text-zumthor-800 dark:bg-zumthor-300',
        { 'border-lynch-600 bg-lynch-600 text-lynch-50 dark:bg-lynch-600': type === 'standard' },
        {
          'border-fair-pink-600 bg-fair-pink-50 text-fair-pink-600 dark:border-fair-pink-800 dark:bg-fair-pink-800 dark:text-fair-pink-50':
            type === 'dangerous',
        },
        {
          'border-mantis-400 bg-mantis-400 text-mantis-50 dark:bg-mantis-400': type === 'success',
        },
        {
          'border-purple-400 bg-purple-100 text-purple-800 dark:border-purple-500 dark:bg-purple-900 dark:text-purple-100':
            type === 'warning',
        },
        {
          'border-quarter-spanish-white-600 bg-quarter-spanish-white-600 text-quarter-spanish-white-50 dark:border-quarter-spanish-white-600 dark:bg-quarter-spanish-white-600 dark:text-quarter-spanish-white-50':
            type === 'high',
        },
        {
          'border-quarter-spanish-white-400 bg-quarter-spanish-white-400 text-quarter-spanish-white-950 dark:border-quarter-spanish-white-400 dark:bg-quarter-spanish-white-400 dark:text-quarter-spanish-white-950':
            type === 'medium',
        },

        {
          'border-quarter-spanish-white-200 bg-quarter-spanish-white-200 text-quarter-spanish-white-800 dark:border-quarter-spanish-white-200 dark:bg-quarter-spanish-white-200 dark:text-quarter-spanish-white-800':
            type === 'low',
        },

        className,
      )}
      ref={ref}>
      {children}
    </span>
  );
};

export default BadgeContainer;
